export const translationsTh = {
  Quantity: 'จำนวน',
  Out_of_stock: 'สินค้าหมด',
  Price: 'ราคา',
  Select: 'เลือก',
  Cancel: 'ยกเลิก',
  Buy_now: 'สั่งซื้อ',
  Search: 'ค้นหาสินค้า',
  product_not_found: 'ไม่พบสินค้า',
  product_category_not_found: 'ไม่พบสินค้าในหมวดหมู่นี้',
  Back: 'ย้อนกลับ',
  shop_not_found: 'ไม่พบร้านค้า'
}



// WEBPACK FOOTER //
// ./src/store/i18n/th.js